var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8611_254371)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_8611_254371)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8611_254371)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4353 49.2201C47.8589 46.7965 49.358 43.4483 49.358 39.75C49.358 30.9634 41.9703 22.9157 38.1687 19.3561C37.2993 18.5421 35.9531 19.1838 35.8811 20.3727C35.1488 32.4728 29.8191 31.7049 27.5324 30.7965C26.9025 30.5463 26.1445 30.6186 25.7083 31.1375C23.7512 33.4659 22.5723 36.4702 22.5723 39.75C22.5723 43.4483 24.0713 46.7965 26.495 49.2202C28.9186 51.6438 32.2668 53.1428 35.9651 53.1428C39.6635 53.1428 43.0117 51.6438 45.4353 49.2201ZM40.0057 45.6986C41.0398 44.6298 41.6794 43.1532 41.6794 41.5223C41.6794 38.5693 39.7748 35.8295 38.5049 34.3311C38.1025 33.8562 37.3816 34.1523 37.3316 34.7727C36.8435 40.8203 33.5986 41.1916 31.8267 39.7387C31.3771 39.3701 30.6051 39.3888 30.4554 39.9505C30.3221 40.451 30.2508 40.978 30.2508 41.5223C30.2508 43.1533 30.8904 44.6298 31.9245 45.6986C32.9586 46.7675 34.3872 47.4285 35.9651 47.4285C37.5431 47.4285 38.9716 46.7675 40.0057 45.6986Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8611_254371",
    x1: 0,
    y1: 0,
    x2: 72,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8611_254371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8611_254371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.e29e4d79.svg";
export { ForwardRef as ReactComponent };